module.exports = __webpack_public_path__ + "img/kingyo_cours_jap.7849c595.svg";